import { useAtomValue } from "jotai";

import { $pageMetadataBySlugPath } from "../../internal/page-metadata/page-metadata.atom";
import { useDocumentIdOverride } from "./DocumentIdContext";
import { useMetadataKeyForCurrRoute } from "./useMetadataKeyForCurrRoute";
import { useRouteParams } from "./useRouteParams";

export const usePageFromCurrentRoute = () => {
	const { documentId, pageSlug } = useRouteParams();
	const metadataKey = useMetadataKeyForCurrRoute();
	const override = useDocumentIdOverride();

	// Handle nested page slugs - the catch-all route returns an array of path segments
	// pageSlug is always a string from useRouteParams (empty string if not present)
	const pageMetadata = useAtomValue(
		$pageMetadataBySlugPath({ metadataKey, pageSlug: pageSlug || "" })
	);

	// If a direct pageId override is provided, use it instead of looking up by slug
	const pageId = override?.pageId ?? pageMetadata?.id;

	return {
		documentId,
		pageSlug,

		pageId,
		pageMetadata: pageMetadata ?? undefined,
	};
};
